export class PrivateTradeOrder {
  // Capital Transfer
  country: string;
  phoneNumber: string;
  fullName: string;
  bankName: string;
  nationalId: string;
  accountNumber: string;
  address: string;
  useIntermediaryBank: string;
  intermediaryBank: string;
  intermediaryBankAddress: string;
  swift: string;
  aba: string;
  iban: string;
  bankPaymentMethod: string;
  methodName: string;
  makerSendFirst: boolean;

  guaranteeOf: string;
  warranty: number;
  commission: number;
  fee: number;
  totalSend: string;
  currencyToSend: string;
  totalReceive: string;
  currencyToReceive: string;
  percentage: string;
  currencyPercentage: string;
  transferTypeId: string;
  btnPosition: string;
  totalToSendSumary: string;
  totalToReceiveSumary: string;
  totalToPercentage: string;
  // Capital Transfer
  orderCategory: string; // "PRIVATE_TRADE",
  coinShortName: string;
  currency: string;
  amount: number;
  orderType: string; // "BUY",
  priceEquationString: string;
  additionalInstruction: string;
  initialMessage: string;
  imageUrl: string;
  username: string;
  email: string;
  phoneOrEmail: string;
  firstName: string;
  lastName: string;
  city: string;
  giftCardType: string;
  otherDetails: string;
  acceptedBankName: string;

  otherBankName: string;
  state: string;
  additionalInstructionPaymentMethod: string;
  otherMethodName: string;
  international: true;
  paymentSentTimeInMinutes: number;
  paymentMethodDataUIArr: any;
  //real estate
  propertyName: string;
  propertyAddress: string
  documents: any
  total: number;
  transferType: string; // "CASH_CASH",
  firstOtherName: string;
  firstDescription: string;
  secondOtherName: string;
  secondDescription: string;
  collateralRequired: boolean; //true
  collateralPercentage: number;
  makerCollateral: boolean; // true
  commissionPercentage: number;
  makerTakesCommission: boolean; // true
  tranfer_send: string;
  tranfer_recipient: string;
  currencyCash: string;
  nameOther: string
  descriptionOther: string
  nameOther2: string
  descriptionOther2: string
  symbol: string
  amountOfTime: string
}